import { useState, useRef } from "react";
import "./index.css";

export const Tooltip: React.FC<{
  title: string;
  children: React.ReactNode;
  description?: string;
  position?: "top" | "left" | "right";
}> = ({ title, description, children, position = "top" }) => {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const ref = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    const rect = ref.current?.getBoundingClientRect();

    if (rect) {
      let top = rect.top - 12;
      let left = rect.left + rect.width / 2;

      if (position === "left") {
        left = rect.left - 10;
      }

      if (position === "right") {
        left = rect.right + 10;
      }

  setPos({ top, left });
}


    setVisible(true);
  };

  return (
    <div
      ref={ref}
      style={{ display: "inline-block" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      {visible && (
        <div
          className="tooltip-fixed"
          style={{
            top: pos.top,
            left: pos.left,
          }}
        >
          <div className="tooltip-content">
            <div className="tooltip-title">{title}</div>
            {description && (
              <div className="tooltip-desc">{description}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};